import { ClientSelect } from '@features/client/components/client-select';
import { useClientsQuery } from '@features/client/queries';
import { ServiceSelect } from '@features/service/components/ServiceSelect';
import { getServiceDurationMinutes } from '@features/service/entity';
import { useServicesQuery } from '@features/service/queries';
import { CreateVisitType } from '@features/visits/entity';
import { useCreateVisitMutation } from '@features/visits/queries';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { SubmitFormDialog } from '@shared/components/dialogs/submit-form-dialog';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { VisitDailyOverviewFastOrderFormSubtitle } from './visit-daily-overview-fast-order-form-subtitle';

type VisitDailyOverviewFastOrderFormProps = {
  dialogRef: React.Ref<ImperativeFormDialogRefType> | null;
  methods: ReturnType<typeof useForm<CreateVisitType>>;
};

export const VisitDailyOverviewFastOrderForm = ({
  dialogRef,
  methods,
}: VisitDailyOverviewFastOrderFormProps) => {
  const { t } = useIntlTranslations();
  const { data: clients } = useClientsQuery();
  const { data: services = [] } = useServicesQuery();
  const clientId = methods.watch('clientId');
  const dateTime = methods.watch('date');
  const serviceId = methods.watch('serviceIds');

  const clientName = clients?.find(c => c.id === clientId);
  const selectedService = services.find(s => s.id === serviceId);

  const endDateTime =
    dateTime && selectedService
      ? dayjs(dateTime).add(getServiceDurationMinutes(selectedService), 'minute').toDate()
      : undefined;

  const { mutate: createVisitMutation } = useCreateVisitMutation({
    onSuccess: () => {
      methods.reset({ depositRequired: false });
    },
  });

  return (
    <SubmitFormDialog
      ref={dialogRef}
      methods={methods}
      onSubmit={createVisitMutation}
      title={t('order')}
    >
      <VisitDailyOverviewFastOrderFormSubtitle
        dateTime={dateTime}
        endDateTime={endDateTime}
        firstName={clientName?.firstName}
        lastName={clientName?.lastName}
      />
      <ClientSelect clientId={clientId} />
      <ServiceSelect
        onChange={service => {
          methods.setValue(
            'dateTo',
            dayjs(dateTime).add(getServiceDurationMinutes(service), 'minute').toDate(),
          );
        }}
      />
    </SubmitFormDialog>
  );
};
